export default "/_next/static/images/1555ceb4bab40ad4396da4bc86d14e66.jpg";